type SparklineProps = {
  values: number[];      // 0-100 percentages, oldest → newest
  width?: number;
  height?: number;
  className?: string;
};

export function sparklinePoints(
  values: number[],
  width: number,
  height: number,
): string {
  if (values.length < 2) return '';
  const stepX = width / (values.length - 1);
  return values
    .map((v, i) => {
      const x = i * stepX;
      const y = height - (Math.max(0, Math.min(100, v)) / 100) * height;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');
}

export function Sparkline({
  values,
  width = 240,
  height = 56,
  className,
}: SparklineProps) {
  const points = sparklinePoints(values, width, height);
  if (!points) return null;
  const last = values[values.length - 1];
  const lastX = width;
  const lastY = height - (Math.max(0, Math.min(100, last)) / 100) * height;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label={`Trend over ${values.length} snapshots, current ${last}%`}
    >
      <polyline
        points={points}
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <circle cx={lastX} cy={lastY} r={3} fill="currentColor" />
    </svg>
  );
}
